var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { buildGeminiAdoptionTrendExportRows, buildGeminiAdoptionTrendTeamChartData, buildGeminiAdoptionTrendUserChartData, GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS, GEMINI_ADOPTION_TREND_TEAM_CURRENT_STACK_DATA_KEYS, GEMINI_ADOPTION_TREND_TEAM_PREVIOUS_STACK_DATA_KEYS, geminiAdoptionTrendTeamDataKey, geminiAdoptionTrendUserYAxisTickFormatter } from '@web/components/Apps/Gemini/geminiAdoptionTrendChart';
import { buildGeminiFilterPeriodTooltipLabels } from '@web/components/Apps/Gemini/geminiChartTooltipLabels';
import { ClickableGeminiUsageLevelLegend, formatGeminiUsageLevelLabel } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, getBarChartRowPayload, navigateToAppsUsageForDateRange } from '@web/utility/chartNavigation';
import { getPeriodBarChartLayoutProps } from '@web/utility/charts';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared';
import { GEMINI_USAGE_LEVELS, isGeminiAdoptionTrendVisible } from '@workalizer/shared/lib/gemini-usage-level';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var I18N = 'app.apps.gemini.adoptionTrend';
var geminiAdoptionTrendTeamStripePatternId = function (level) {
    return "".concat(InsightTypeEnum.geminiAdoptionTrend, "_team_").concat(level);
};
function GeminiAdoptionTrendTeamChart(_a) {
    var data = _a.data, chartPlotEmpty = _a.chartPlotEmpty, toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible, onBarCellClick = _a.onBarCellClick;
    var t = useTranslation().t;
    var metricLabels = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
        acc[level.toLowerCase()] = formatGeminiUsageLevelLabel(level, true, t);
        return acc;
    }, {});
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(metricLabels);
    var tooltipSeriesOrder = __spreadArray(__spreadArray([], GEMINI_ADOPTION_TREND_TEAM_PREVIOUS_STACK_DATA_KEYS, true), GEMINI_ADOPTION_TREND_TEAM_CURRENT_STACK_DATA_KEYS, true);
    var _b = getPeriodBarChartLayoutProps({
        barGroupCount: data.length,
        barsPerGroup: 2
    }), barGap = _b.barGap, barSize = _b.barSize, periodXAxis = _b.periodXAxis, periodBarChartMargin = _b.periodBarChartMargin;
    var renderTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter, formatValue: function (value, dataKey, _label, row) {
            var _a;
            var level = GEMINI_USAGE_LEVELS.find(function (usageLevel) {
                return geminiAdoptionTrendTeamDataKey('current', usageLevel) === dataKey ||
                    geminiAdoptionTrendTeamDataKey('previous', usageLevel) === dataKey;
            });
            if (!level || !row) {
                return "".concat(value, "%");
            }
            var isPrevious = String(dataKey).startsWith('previous');
            var levelCounts = isPrevious
                ? row.previousLevelCounts
                : row.levelCounts;
            var count = (_a = levelCounts === null || levelCounts === void 0 ? void 0 : levelCounts[level]) !== null && _a !== void 0 ? _a : 0;
            return "".concat(count, " ").concat(t(count === 1
                ? 'app.apps.gemini.adoptionTrend.user'
                : 'app.apps.gemini.adoptionTrend.users'), " (").concat(value, "%)");
        } }), data.length);
    var stackedBarCellProps = function (dataIndex, stack) { return ({
        onClick: function () { return onBarCellClick(dataIndex, stack); },
        style: { cursor: 'pointer' }
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(ClickableGeminiUsageLevelLegend, { t: t, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible }), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: data, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "name", axisLine: false, tickLine: false }, periodXAxis)), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, width: 48, domain: [0, 100], tickFormatter: function (value) { return "".concat(value, "%"); } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS.previous.map(function (config, index) {
                                var level = GEMINI_USAGE_LEVELS[index];
                                return (_jsx(Bar, __assign({}, config, { name: seriesLabelFormatter(config.dataKey), hide: !isSeriesVisible(level) }, { children: renderStackedBarCells({
                                        chartData: data,
                                        stackDataKeys: GEMINI_ADOPTION_TREND_TEAM_PREVIOUS_STACK_DATA_KEYS,
                                        segmentIndex: index,
                                        keyPrefix: "prev-".concat(config.dataKey),
                                        getCellProps: function (_entry, dataIndex) {
                                            return stackedBarCellProps(dataIndex, ComparisonPeriod.Previous);
                                        }
                                    }) }), config.dataKey));
                            }), GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS.current.map(function (config, index) {
                                var level = GEMINI_USAGE_LEVELS[index];
                                return (_jsx(Bar, __assign({}, config, { name: seriesLabelFormatter(config.dataKey), hide: !isSeriesVisible(level) }, { children: renderStackedBarCells({
                                        chartData: data,
                                        stackDataKeys: GEMINI_ADOPTION_TREND_TEAM_CURRENT_STACK_DATA_KEYS,
                                        segmentIndex: index,
                                        keyPrefix: "curr-".concat(config.dataKey),
                                        getCellProps: function (_entry, dataIndex) {
                                            return stackedBarCellProps(dataIndex, ComparisonPeriod.Current);
                                        }
                                    }) }), config.dataKey));
                            })] })) })) }))] }));
}
function GeminiAdoptionTrendUserChart(_a) {
    var data = _a.data, chartPlotEmpty = _a.chartPlotEmpty, showTeamAverage = _a.showTeamAverage, toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible, onBarClick = _a.onBarClick;
    var t = useTranslation().t;
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(__assign({ previousValue: t('export.previous'), currentValue: t('export.current') }, (showTeamAverage && { teamValue: t('export.teamAverage') })));
    var teamStripePatterns = showTeamAverage
        ? GEMINI_USAGE_LEVELS.map(function (level) { return ({
            patternId: geminiAdoptionTrendTeamStripePatternId(level),
            chartColor: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].teamChartColor
        }); })
        : [];
    var _b = getPeriodBarChartLayoutProps({
        barGroupCount: data.length,
        barsPerGroup: showTeamAverage ? 3 : 2
    }), barGap = _b.barGap, barSize = _b.barSize, periodXAxis = _b.periodXAxis, periodBarChartMargin = _b.periodBarChartMargin;
    var displayData = data.map(function (entry) { return (__assign(__assign(__assign({}, entry), { previousValue: isSeriesVisible(entry.previousLevel)
            ? entry.previousValue
            : 0, currentValue: isSeriesVisible(entry.currentLevel) ? entry.currentValue : 0 }), (showTeamAverage && {
        teamValue: isSeriesVisible(entry.teamLevel) ? entry.teamValue : 0
    }))); });
    var resolveAdoptionTrendSwatchColor = function (dataKey, row) {
        if (!row) {
            return undefined;
        }
        if (dataKey === 'previousValue') {
            var level = row.previousLevel;
            return {
                color: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].prevChartColor
            };
        }
        if (dataKey === 'currentValue') {
            var level = row.currentLevel;
            return {
                color: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].chartColor
            };
        }
        if (dataKey === 'teamValue') {
            var level = row.teamLevel;
            return {
                color: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].teamChartColor,
                stripe: true
            };
        }
        return undefined;
    };
    var renderTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: showTeamAverage
            ? ['previousValue', 'currentValue', 'teamValue']
            : ['previousValue', 'currentValue'], periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter, formatValue: function (_value, dataKey, _label, row) {
            if (!row) {
                return '';
            }
            if (dataKey === 'previousValue') {
                return formatGeminiUsageLevelLabel(row.previousLevel, true, t);
            }
            if (dataKey === 'currentValue') {
                return formatGeminiUsageLevelLabel(row.currentLevel, true, t);
            }
            return formatGeminiUsageLevelLabel(row.teamLevel, true, t);
        }, resolveSwatchColor: resolveAdoptionTrendSwatchColor }), data.length);
    return (_jsxs(_Fragment, { children: [_jsx(ClickableGeminiUsageLevelLegend, { t: t, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible }), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: displayData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [rechartsDiagonalStripePatternDefs(teamStripePatterns), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "name", axisLine: false, tickLine: false }, periodXAxis)), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, width: 72, domain: [0, 4], ticks: [1, 2, 3, 4], tickFormatter: geminiAdoptionTrendUserYAxisTickFormatter(t) }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), _jsx(Bar, __assign({ dataKey: "previousValue", radius: [4, 4, 0, 0], onClick: function (barData) {
                                    var payload = getBarChartRowPayload(barData);
                                    if (payload) {
                                        onBarClick(payload, ComparisonPeriod.Previous);
                                    }
                                }, style: { cursor: 'pointer' } }, { children: displayData.map(function (entry) { return (_jsx(Cell, { fill: entry.previousValue > 0
                                        ? GEMINI_USAGE_LEVEL_COLORS_CONFIG[entry.previousLevel]
                                            .prevChartColor
                                        : 'transparent' }, "prev-".concat(entry.period))); }) })), _jsx(Bar, __assign({ dataKey: "currentValue", radius: [4, 4, 0, 0], onClick: function (barData) {
                                    var payload = getBarChartRowPayload(barData);
                                    if (payload) {
                                        onBarClick(payload, ComparisonPeriod.Current);
                                    }
                                }, style: { cursor: 'pointer' } }, { children: displayData.map(function (entry) { return (_jsx(Cell, { fill: entry.currentValue > 0
                                        ? GEMINI_USAGE_LEVEL_COLORS_CONFIG[entry.currentLevel]
                                            .chartColor
                                        : 'transparent' }, "curr-".concat(entry.period))); }) })), showTeamAverage && (_jsx(Bar, __assign({ dataKey: "teamValue", radius: [4, 4, 0, 0], onClick: function (barData) {
                                    var payload = getBarChartRowPayload(barData);
                                    if (payload) {
                                        onBarClick(payload, ComparisonPeriod.Current);
                                    }
                                }, style: { cursor: 'pointer' } }, { children: displayData.map(function (entry) { return (_jsx(Cell, { fill: entry.teamValue > 0
                                        ? rechartsDiagonalStripeFillUrl(geminiAdoptionTrendTeamStripePatternId(entry.teamLevel))
                                        : 'transparent' }, "team-".concat(entry.period))); }) })))] })) })) }))] }));
}
export function GeminiAdoptionTrend() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var navigateTo = useNavigateTo();
    var isVisible = isGeminiAdoptionTrendVisible(dateFrom, dateTo);
    var _b = trpc.geminiAdoptionTrend.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnit,
        userId: user
    }, { enabled: isVisible }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (!isVisible) {
        return null;
    }
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var isUserView = Boolean(user);
    var showTeamAverage = isUserView && data.weeks.some(function (week) { return week.teamUserLevel != null; });
    var filterPeriodLabels = buildGeminiFilterPeriodTooltipLabels(dateFrom, dateTo);
    var teamChartData = buildGeminiAdoptionTrendTeamChartData(data, {
        filterPeriodLabels: filterPeriodLabels,
        dateFrom: dateFrom,
        dateTo: dateTo
    });
    var handleTeamBarCellClick = function (dataIndex, stack) {
        var row = teamChartData[dataIndex];
        if (!row) {
            return;
        }
        if (stack === ComparisonPeriod.Previous &&
            row.previousDateFrom &&
            row.previousDateTo) {
            navigateToAppsUsageForDateRange({
                navigateTo: navigateTo,
                dateFrom: row.previousDateFrom,
                dateTo: row.previousDateTo,
                userId: user,
                orgUnitId: orgUnit,
                tab: 'gemini'
            });
            return;
        }
        navigateToAppsUsageForDateRange({
            navigateTo: navigateTo,
            dateFrom: row.dateFrom,
            dateTo: row.dateTo,
            userId: user,
            orgUnitId: orgUnit,
            tab: 'gemini'
        });
    };
    var handleUserBarClick = function (row, stack) {
        if (stack === ComparisonPeriod.Previous &&
            row.previousDateFrom &&
            row.previousDateTo) {
            navigateToAppsUsageForDateRange({
                navigateTo: navigateTo,
                dateFrom: row.previousDateFrom,
                dateTo: row.previousDateTo,
                userId: user,
                orgUnitId: orgUnit,
                tab: 'gemini'
            });
            return;
        }
        navigateToAppsUsageForDateRange({
            navigateTo: navigateTo,
            dateFrom: row.dateFrom,
            dateTo: row.dateTo,
            userId: user,
            orgUnitId: orgUnit,
            tab: 'gemini'
        });
    };
    var exportRows = buildGeminiAdoptionTrendExportRows(data, isUserView, t, I18N);
    var chartPlotEmpty = isInsightsDataEmpty(data);
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: "".concat(I18N, ".title"), description: "".concat(I18N, ".tooltip"), insightType: InsightTypeEnum.geminiAdoptionTrend, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(I18N, ".title")), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, exportRows];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: _jsx(ChartSeriesVisibility, __assign({ seriesKeys: GEMINI_USAGE_LEVELS }, { children: function (_a) {
                        var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                        return isUserView ? (_jsx(GeminiAdoptionTrendUserChart, { data: buildGeminiAdoptionTrendUserChartData(data.weeks), chartPlotEmpty: chartPlotEmpty, showTeamAverage: showTeamAverage, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible, onBarClick: handleUserBarClick })) : (_jsx(GeminiAdoptionTrendTeamChart, { data: teamChartData, chartPlotEmpty: chartPlotEmpty, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible, onBarCellClick: handleTeamBarCellClick }));
                    } })) }))] }));
}
